import { Link } from "react-router-dom";
import { Button } from "../../components/button";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
 
import { useEffect } from "react";
import UsersService from "../../services/UserService";
import { useAuth } from "../../context/AuthContext";
// update text and descriptions to match NClood app for charity donation
import DonateIcon from "../../components/icons/DonateIcon";
import CommunityIcon from "../../components/icons/CommunityIcon";
import ImpactIcon from "../../components/icons/ImpactIcon";
// generate a home page for nclood app for charity donations and events participations
import EventsIcon from "../../components/icons/EventsIcon";
import VolunteerIcon from "../../components/icons/VolunteerIcon";
import FundraisingIcon from "../../components/icons/FundraisingIcon";

export default function HomePage() {
  const {user} = useAuth();

  useEffect(() => {
    // if (user) {
    //   UsersService.getUser(user.id).then((response) => {
    //     console.log(response.data);
    //   });
    // }
  }, [user]);
 
   return (
    <main className="bg-white text-gray-800">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-purple-500 to-purple-800 text-white py-20 px-4 sm:px-6 lg:px-8">
        <div className="absolute inset-0 bg-black opacity-20"></div>
        <div className="relative max-w-7xl mx-auto text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-tight mb-6">
            Empowering Change Through Giving
          </h1>
          <p className="text-lg sm:text-xl mb-8 max-w-3xl mx-auto">
            Join NClood to make a real difference. Donate to causes you care
            about, participate in impactful events, and build a stronger
            community together.
          </p>
          {/* <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4">
            <Link to="/">
              <Button type="button" className="bg-white hover:text-white  hover:bg-purple-500 px-8 py-3 rounded-full text-lg font-semibold shadow-lg transition duration-300 ease-in-out transform hover:scale-105">
                <span className="text-purple-600 hover:text-white ">Donate Now <ArrowRightIcon className="ml-2 h-5 w-5 inline" /></span>
              </Button>
            </Link>
            <Link to="/events">
              <Button type="button" className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-purple-600 px-8 py-3 rounded-full text-lg font-semibold shadow-lg transition duration-300 ease-in-out transform hover:scale-105">
                Explore Events
              </Button>
            </Link>
          </div> */}
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
              How You Can Help
            </h2>
            <p className="mt-4 text-lg text-gray-600">
              Discover the different ways you can contribute to our community.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-lg shadow-md text-center">
              <DonateIcon className="h-12 w-12 mx-auto text-purple-500" />
              <h3 className="mt-6 text-xl font-bold text-gray-900">Donate</h3>
              <p className="mt-2 text-base text-gray-600">
                Your donations help us support various causes and make a
                tangible impact on people's lives.
              </p>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-md text-center">
              <EventsIcon className="h-12 w-12 mx-auto text-purple-500" />
              <h3 className="mt-6 text-xl font-bold text-gray-900">
                Participate in Events
              </h3>
              <p className="mt-2 text-base text-gray-600">
                Join our events to engage with the community and support causes
                in a hands-on way.
              </p>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-md text-center">
              <VolunteerIcon className="h-12 w-12 mx-auto text-yellow-500" />
              <h3 className="mt-6 text-xl font-bold text-gray-900">
                Volunteer
              </h3>
              <p className="mt-2 text-base text-gray-600">
                Lend your time and skills to make a difference. Every hour you
                contribute helps.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="lg:text-center">
            <h2 className="text-base text-purple-600 font-semibold tracking-wide uppercase">
              Why NClood
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              A Better Way to Give Back
            </p>
            <p className="mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto">
              We provide a transparent, impactful, and community-driven
              platform for your charitable activities.
            </p>
          </div>

          <div className="mt-10">
            <dl className="space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10">
              <div className="relative">
                <dt>
                  <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-purple-500 text-white">
                    <ImpactIcon className="h-6 w-6" aria-hidden="true" />
                  </div>
                  <p className="ml-16 text-lg leading-6 font-medium text-gray-900">
                    Track Your Impact
                  </p>
                </dt>
                <dd className="mt-2 ml-16 text-base text-gray-500">
                  See exactly where your donations go and the impact they have
                  on the community.
                </dd>
              </div>

              <div className="relative">
                <dt>
                  <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-purple-500 text-white">
                    <CommunityIcon className="h-6 w-6" aria-hidden="true" />
                  </div>
                  <p className="ml-16 text-lg leading-6 font-medium text-gray-900">
                    Join a Community
                  </p>
                </dt>
                <dd className="mt-2 ml-16 text-base text-gray-500">
                  Connect with like-minded individuals who are passionate about
                  making a difference.
                </dd>
              </div>

              <div className="relative">
                <dt>
                  <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-purple-500 text-white">
                    <FundraisingIcon className="h-6 w-6" aria-hidden="true" />
                  </div>
                  <p className="ml-16 text-lg leading-6 font-medium text-gray-900">
                    Easy Fundraising
                  </p>
                </dt>
                <dd className="mt-2 ml-16 text-base text-gray-500">
                  Create and manage fundraising campaigns for causes you are
                  passionate about.
                </dd>
              </div>

              <div className="relative">
                <dt>
                  <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-purple-500 text-white">
                    <EventsIcon className="h-6 w-6" aria-hidden="true" />
                  </div>
                  <p className="ml-16 text-lg leading-6 font-medium text-gray-900">
                    Engaging Events
                  </p>
                </dt>
                <dd className="mt-2 ml-16 text-base text-gray-500">
                  Participate in a variety of events, from charity runs to
                  community workshops.
                </dd>
              </div>
            </dl>
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="bg-gray-50">
        <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8 lg:flex lg:items-center lg:justify-between">
          <h2 className="text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">
            <span className="block">Ready to make a difference?</span>
            <span className="block text-purple-600">Join NClood today.</span>
          </h2>
          <div className="mt-8 flex lg:mt-0 lg:flex-shrink-0">
            <div className="inline-flex rounded-md shadow">
              <Link to="/auth/register">
                <Button className="bg-purple-600 text-white hover:bg-purple-700 px-8 py-3 rounded-full text-lg font-semibold transition duration-300 ease-in-out">
                  Get Started
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}